// extracted by mini-css-extract-plugin
var _1 = "ra-quiz-result-section-centered";
var _2 = "ra-quiz-result-share-wrapper";
export { _1 as "quizSectionCenteredCls", _2 as "quizShareWrapperCls" }
